import React from "react";
import "./Banner.css";
import AboutBg from "../assets/Events-banner.png"; // replace with your actual image path

export default function AboutHeader() {
  return (
    <section
      className="aheader-wrapper"
      style={{ backgroundImage: `url(${AboutBg})` }}
    >
      <div className="aheader-overlay">
        <h1 className="aheader-title">Events</h1>
        <p className="aheader-breadcrumb">
          Home <span className="aheader-separator">›</span> Events
        </p>
      </div>
    </section>
  );
}
